import React, { useState } from 'react';
import { Outlet, useMatch, Link } from 'react-router-dom';
import { Button, Container } from 'react-bootstrap';
import { AdminPanel } from '../../components/admin-panel/adminPanel.jsx';

export function Admin() {
  const isRootAdmin = useMatch("/admin");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  return (
    <div className="admin-layout d-flex">
      {isSidebarOpen && <div className="sidebar-overlay d-lg-none" onClick={toggleSidebar}></div>}
      
      <AdminPanel show={isSidebarOpen} onToggle={toggleSidebar} />

      {/* ВАЖНО: Класс admin-content должен быть здесь */}
      <div className="admin-content flex-grow-1">
        
        {/* Мобильная шапка (видна только на маленьких экранах) */}
        <div className="d-lg-none bg-dark text-white p-3 d-flex align-items-center mb-4 shadow-sm">
          <Button variant="outline-light" className="me-3" onClick={toggleSidebar}>
            <i className="bi bi-list fs-4"></i>
          </Button>
          <h5 className="m-0 fw-bold">Панель управления</h5>
        </div>

        <Container fluid className="py-4 px-md-5">
          {isRootAdmin && (
            <div className="text-center mt-5">
              <h1 className="display-5 fw-bold text-dark">Панель администратора</h1>
              <p className="text-muted fs-5">Выберите нужный раздел в меню слева для настройки сайта.</p>
              <div className="d-flex justify-content-center gap-3 mt-4">
                <Button as={Link} to="/admin/edit" className="btn-corp">Услуги</Button>
                <Button as={Link} to="/admin/stat" variant="outline-dark">Аналитика</Button>
              </div>
            </div>
          )}
          <Outlet />
        </Container>
      </div>
    </div>
  );
}
